<template>
  <div class="header">
    <div class="header-content">
      <div class="bar-wrapper">
        <div class="bar-container" v-click-outside="hideMenu">
          <img src="@/assets/image/header/logo@2x.png" class="logo" @click="routerPush('Home')">
          <div class="mb-nav">
            <div class="special-bar-icon" @click="toggleMenuShow">
              <i :class="{ active: menuListVisible }" class="inv-menu-icon"></i>
            </div>
          </div>
          <div v-show="menuListVisible" class="menu-container">
            <div class="nav">
              <div class="item" v-for="(item,index) in navList" :key="index"
                   @click="routerPush(item.route, item.isLink)">
                {{ item.name }}
              </div>
            </div>
            <div class="account">
              <div v-if="!loggedin" class="no-login">
                <md-button type="primary" class="item" @click="routerPush('Login')">
                  {{ $t('login') }}
                </md-button>
                <!--<md-button type="default" class="item" @click="routerPush('Signup')">-->
                  <!--{{ $t('register') }}-->
                <!--</md-button>-->
              </div>
              <div v-if="loggedin" class="logined">
                <md-button type="primary" class="item" @click="routerPush('UserOverview')">
                  {{ $t('myIdrAccount') }}
                </md-button>
                <md-button type="default" class="item" @click="routerPush('Logout')">
                  {{ $t('logout') }}
                </md-button>
              </div>
            </div>
            <div class="language">
              <div class="item" @click="changeLang('en')">
                <img src="@/assets/image/header/en-new.png" class="lang-icon">
                English
              </div>
              <div class="item" @click="changeLang('id')">
                <img src="@/assets/image/header/id-new.png" class="lang-icon">
                Indonesia
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        home: 'Home',
        flexibleInvestment: 'Flexible Investment',
        fixedInvestment: 'Fixed Term Investment',
        companyProfile: 'Company Profile',
        blog: 'Blog',
        media: 'Media',
        faq: 'FAQ',
        login: 'Login',
        logout: 'Logout',
        myIdrAccount: 'My IDR Account',
        register: 'Sign Up',
      },
      id: {
        home: 'Halaman Utama',
        flexibleInvestment: 'Pendanaan Fleksibel',
        fixedInvestment: 'Pendanaan Berjangka',
        companyProfile: 'Profil Perusahaan',
        blog: 'Blog',
        media: 'Media',
        faq: 'FAQ',
        login: 'Masuk',
        logout: 'Logout',
        myIdrAccount: 'My IDR Account',
        register: 'Daftar',
      },
    },
  },
  components: {
    [Button.name]: Button,
  },
  data() {
    const navList = [
      { name: this.$t('home'), route: 'Home' },
      // { name: this.$t('flexibleInvestment'), route: 'FlexibleProduct' },
      { name: this.$t('fixedInvestment'), route: 'Product' },
      { name: this.$t('companyProfile'), route: 'CompanyProfile' },
      { name: this.$t('blog'), route: 'https://www.kreditpintar.com/blog/', isLink: true },
      { name: this.$t('media'), route: 'https://www.kreditpintar.com/blog/media', isLink: true },
      { name: this.$t('faq'), route: 'Faq' },
    ]
    const navListForDS = [
      { name: this.$t('home'), route: 'Home' },
      { name: this.$t('fixedInvestment'), route: 'Product' },
      { name: this.$t('companyProfile'), route: 'CompanyProfile' },
      { name: this.$t('blog'), route: 'https://www.kreditpintar.com/blog/', isLink: true },
      { name: this.$t('media'), route: 'https://www.kreditpintar.com/blog/media', isLink: true },
    ]
    return {
      navList: this.$config.needElectronicContract ? navListForDS : navList,
      menuListVisible: false,
    }
  },
  computed: {
    loggedin() {
      return this.$store.getters.loggedin
    },
  },
  methods: {
    routerPush(route, isLink) {
      this.menuListVisible = false
      if (isLink) {
        window.open(route, '_blank')
      } else {
        this.$router.push({ name: route })
      }
    },
    toggleMenuShow() {
      this.menuListVisible = !this.menuListVisible
    },
    hideMenu() {
      this.menuListVisible = false
    },
    changeLang(locale) {
      this.$store.commit('updateLocale', locale)
      window.vue.$i18n.locale = locale
      location.reload()
      this.hideMenu()
    },
  },
}
</script>

<style lang="stylus" scoped>
.warning {
  color: #e1b400;
  background: rgba(#000000, 0.4);
  padding: 20px;
}

.header {
  text-align: center;
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 64px;
  background: #ffffff;
  box-shadow: 0 5px 11px 0 rgba(50, 50, 50, 0.08);
}

.header-content {
  display: flex;
  margin: auto;
  height: 100%;
  padding-top: 0;
}

.logo {
  display: inline-block;
  cursor: pointer;
  width: 152px;
  height: 32px;
}

.bar-wrapper {
  width: 100%;
}

.bar-container {
  text-align: left;
  padding: 16px 8px 0;
  position: relative;
  .mb-nav {
    float: right;
    display: flex;
    flex-direction: row-reverse;
    .special-bar-icon {
      font-size: 32px;
      width: 40px;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
  }
  .menu-container {
    position: absolute;
    right: 0;
    top: 59px;
    left: 0;
    margin-top: 5px;
    background: #fff;
    text-align: left;
    padding: 16px 0;
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    max-height: calc(100vh - 64px);
    overflow-y: scroll;
    .nav {
      .item {
        font-size 16px
        padding: 16px 16px;
      }
      .nav-link {
        color: unset;
        text-decoration: none;
      }
    }
    .account {
      padding: 16px;
      border-top: 1px solid #e6e6e6;
      border-bottom: 1px solid #e6e6e6;
      .no-login {
        display: flex;
        justify-content: space-around;
        .item {
          width: 48%;
        }
      }
      .logined {
        display: flex;
        justify-content: space-around;
        .item {
          &:nth-of-type(1) {
            width: 58%;
          }
          &:nth-of-type(2) {
            width: 38%;
          }
        }
      }
    }
    .language {
      display: flex;
      padding: 16px;
      text-align: center;
      border-bottom: 1px solid #e6e6e6;
      .item {
        width: 50%;
        &:first-of-type {
          border-right: 1px solid #e6e6e6;
        }
      }
    }
  }
}

.lang-icon {
  width: 32px;
  height: 22px;
  margin-right: 16px;
  vertical-align: middle;
}

.inv-menu-icon {
  display: block;
  width: 28px;
  height: 1px;
  background: #000;
  margin: 20px 0 0 4px;
  position: relative;
  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: -8px;
    width: 100%;
    height: 1px;
    background: #000;
    transition: all 0.2s;
    transform: translate3d(0, 0, 0);
  }
  &:after {
    top: auto;
    bottom: -8px;
  }
  &.active {
    background: transparent;
    &:before {
      top: 0;
      transform: rotateZ(-30deg);
    }
    &:after {
      bottom: 0;
      transform: rotateZ(30deg);
    }
  }
}
</style>
